import { useState, useEffect, useCallback } from 'react';

export const usePlural = (input, split) => {

    const getLength = useCallback(() => {
        if (typeof input === 'string' && !!split)
            return input.split(split).length;

        if (typeof input === 'number')
            return input;

        if (Array.isArray(input))
            return input.length;

        return 0;
    }, [input, split])

    const [length, setLength] = useState(getLength());

    useEffect(() => {
        setLength(getLength());
    }, [getLength]);

    return {
        length,
        isPlural: length !== 1,
        isZero: length === 0,
    };
}